import { render, staticRenderFns } from "./PresentationDetailsScheduleList.vue?vue&type=template&id=238d11da"
import script from "./PresentationDetailsScheduleList.vue?vue&type=script&lang=ts"
export * from "./PresentationDetailsScheduleList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports